import { render, staticRenderFns } from "./list.vue?vue&type=template&id=14ec972f&scoped=true"
import script from "./list.vue?vue&type=script&lang=ts"
export * from "./list.vue?vue&type=script&lang=ts"
import style0 from "./list.vue?vue&type=style&index=0&id=14ec972f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ec972f",
  null
  
)

export default component.exports